export class G_StatusTypeViewModel {
    public Id: number;
    public Name: string;
    public StatusType: number;
}
